import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import '../styles/Editors.scoped.scss';

export const CustomFieldFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  return <div className="field-editor-row">
    <label>Custom Field</label>
    <div className='field-editor-input'>
      <AsyncSelect
        entity="custom_field"
        value={field?.customFieldId}
        rootClassName="grow"
        onChange={(id) => onChange({ customFieldId: id })}
      />
    </div>
  </div>
}
